import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { Router, ActivatedRoute} from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BuatProgramPage } from '../buat-program//buat-program.page';
import { InputNilaiPage } from '../input-nilai/input-nilai.page';
import { formatDate } from "@angular/common";
import{ApiService} from '../../../services/api.service';


@Component({
  selector: 'app-detail-classroom',
  templateUrl: './detail-classroom.page.html',
  styleUrls: ['./detail-classroom.page.scss'],
})
export class DetailClassroomPage implements OnInit {

  classroom: string = 'program';

  constructor(
  private popover:PopoverController, 
  public actionSheetController: ActionSheetController, 
  private modalCtrl:ModalController, 
  private navCtrl:NavController,  
  private route: ActivatedRoute, 
  public router:Router, 
  private api:ApiService, 
  public alert:AlertController
  ) { }
  kelasID:any;
  ngOnInit() {
      var id=this.route.snapshot.paramMap.get('id');
      this.kelasID=id;
      this.getKelas(id);   
      this.getToday();   
  }

  kelas:any={};
  getKelas(id)
  {
      this.api.data('guru/kelas?id='+id,'get','').subscribe(data=>{
          this.kelas=data;
          this.getConfigKurikulum();
          this.getDataPresensi();
      })
  }

  tanggal:any
  dataPresensi:any=[];
  loadingPresensi:boolean;

  getDataPresensi()
  {
      this.loadingPresensi=true;
      this.dataPresensi=[];   
      var dt=new Date(this.selectedDate);
      var tanggal=formatDate(dt, 'yyyy-MM-dd', 'en-US'); 
      this.tanggal=tanggal;
      var params='tahun='+this.kelas.tahunID+'&semester='+this.kelas.semester+'&kelas='+this.kelas.kelasID+'&tanggal='+this.tanggal+'&mapel='+this.kelas.mapelID;
      this.api.data('presensi?'+params,'get','').subscribe(data=>{
        this.dataPresensi=data;
        this.loadingPresensi=false;
        this.defaultPresensi(tanggal);    
      })
  }
  selectedDate:any;
  isSaved:boolean;
  defaultPresensi(tanggal)
  {
      for(var i=0; i<this.dataPresensi.length; i++)
      {
        if(this.dataPresensi[i].data[tanggal]==undefined)
        {
            this.dataPresensi[i].data[tanggal]={status:'masuk'}
            this.isSaved=false;
        }else{
            this.isSaved=true;
        }
      }
      console.log(this.dataPresensi);
  }
  getToday()
  {
      var dt=new Date();
      var bulan;
      var tgl;
      if(dt.getMonth()<10) bulan='0'+(dt.getMonth()+1); else bulan=dt.getMonth()+1; 
      if(dt.getDate()<10) tgl='0'+dt.getDate(); else tgl=dt.getDate();
      this.tanggal=dt.getFullYear()+'-'+bulan+'-'+tgl;
      this.selectedDate=this.tanggal;
  }
  getLabel(data,status)
  {
     if(data[this.tanggal]!=undefined && data[this.tanggal].status==status)
     return true;
  }
  loadingSave:boolean;
  saveData()
  {
      this.loadingSave=true;
      var params={
          tahun:this.kelas.tahunID,
          kelas:this.kelas.kelasID,
          semester:this.kelas.semester,
          tanggal:this.selectedDate,
          mapel:this.kelas.mapelID
      }
      this.api.data('presensi','post',{presensi:this.dataPresensi,params:params}).subscribe(data=>{
        this.loadingSave=false;
        this.getDataPresensi();
      },error=>{
        this.loadingSave=false;
        this.getDataPresensi();
      })
  }
  configKurikulum:any={};
  getConfigKurikulum()
  {
      this.api.data('akademik/configkurikulum?tahun='+this.kelas.tahunID+'&tingkat='+this.kelas.tingkat,'get','').subscribe(data=>{
          this.configKurikulum=data;
          this.getKurikulum(data);
      })
  }
  kurikulum:any={};
  getKurikulum(dat)
  {
      this.api.data('akademik/kurikulum?id='+dat.kurikulumID,'get','').subscribe(data=>{
          this.kurikulum=data;
          this.getProgram();
      })
  }
  program:any={};
  getProgram()
  {
      this.program={};
      var params='tahun='+this.kelas.tahunID+'&tingkat='+this.kelas.tingkat+'&semester='+this.kelas.semester+'&mapelID='+this.kelas.mapelID;
      this.api.data('akademik/program?'+params,'get','').subscribe(data=>{
          this.parseProgram(data);
      })
  }
  parseProgram(data)
  {
      for(var i=0; i<data.length; i++)
      {
          if(this.program[data[i].kategori]==undefined)
          {
              this.program[data[i].kategori]=[data[i]];
          }else{
              this.program[data[i].kategori].push(data[i]);
          }
      }
  }
  deleteProgram(id)
  {
    this.api.data('akademik/program/'+id,'delete','').subscribe(data=>{
      this.getProgram();
    })
  }
  async showProgram(ev: any) {
    const popover = await this.popover.create({
        component: MenuHome,
        event: ev,
        cssClass: 'my-custom-class',
        animated: true,
        showBackdrop: true
    });
    return await popover.present();
  }
  async buatProgram(kategori,dat) {
    const modal = await this.modalCtrl.create({
      component: BuatProgramPage,
      componentProps:{
        tingkat:this.kelas.tingkat,
        tahun:this.kelas.tahunID,
        semester:this.kelas.semester,
        mapelID:this.kelas.mapelID,
        kategori:kategori,
        judul:'Buat Program'
      }
    });    
    modal.onDidDismiss()
      .then((data) => {        
        this.getProgram();
    });
    return await modal.present();
  }

  async editProgram(kategori,dat)
  {
      const modal = await this.modalCtrl.create({
      component: BuatProgramPage,
      componentProps:{       
        judul:'Edit Program',
        program:dat
      }
    });    
    modal.onDidDismiss()
      .then((data) => {       
        this.getProgram();
    });
    return await modal.present();
  }

  async inputNilai(dat,program) {
    const modal = await this.modalCtrl.create({
      component: InputNilaiPage,
      componentProps:{
        program:dat,
        kelas:this.kelas,
        dataProgramPenilaian:program       
      }
    });    
    modal.onDidDismiss()
      .then((data) => {
        
    });
    return await modal.present();
  }

  async presentActionSheet(siswa) {
    const actionSheet = await this.actionSheetController.create({
      header: siswa.nama,
      buttons: [{
        text: 'Hadir',        
        handler: () => {
          console.log('Hadir clicked');
        }
      }, {
        text: 'Sakit',       
        handler: () => {
          this.settingPresensi(siswa.siswaID,'sakit');
        }
      }, {
        text: 'Izin',        
        handler: () => {
          this.settingPresensi(siswa.siswaID,'izin');
        }
      }, {
        text: 'Alpha',        
        handler: () => {
          this.settingPresensi(siswa.siswaID,'alpa');
        }
      }]
    });
    await actionSheet.present();
  }

  settingPresensi(siswaID,status)
  {
      var idx=this.dataPresensi.map(function(e){return e.siswaID}).indexOf(siswaID);
      if(idx!=-1)
      {
          this.dataPresensi[idx].data[this.tanggal].status=status;
      }
  }

  async detailProgram(dat,program) {
    const actionSheet = await this.actionSheetController.create({
      header: 'Aksi Program Penilaian',
      buttons: [{
        text: 'Nilai Siswa',
        icon: 'checkmark',
        cssClass: 'colorIcon',
        handler: () => {
          this.inputNilai(dat,program);
        }
      }, {
        text: 'Edit',
        icon: 'create',
        handler: () => {
          this.editProgram(false,dat);
        }
      }, {
        text: 'Delete',
        icon: 'trash',
        handler: () => {
          this.confirm(dat.id);          
        }
      }]
    });
    await actionSheet.present();
  }

   async confirm(id) {
    const alert = await this.alert.create({
      header: 'Hapus Program',
      message: 'Anda yakin akan menghapus program?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            return false;
          }
        }, {
          text: 'YA',
          handler: () => {
            this.deleteProgram(id)
          }
        }
      ]
    });
    await alert.present();
  }

}

@Component({
  selector: 'menu-home',
  templateUrl: 'menu-home.html'
})
export class MenuHome {
   constructor(public popover:PopoverController)
    {

    }
}
